import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";
import "fg-loadcss/src/cssrelpreload";
import { debounce } from "debounce";

let common = require('./modules/common');

let _internals = {
    reviewSlider: null,
    mediaChecker: null,
    swiper: null,
    initReviewSlider: function () {
        import(/* webPackChunkName: "swiper" */ './modules/swiper').then(function (module) {
            _internals.swiper = module.default;
            _internals.mediaChecker = window.matchMedia('(min-width:1000px)');
            _internals.mediaChecker.addListener(_internals.initReviewSliderInternal);
            _internals.initReviewSliderInternal();
        }, function (e) {
            console.log('Unable to load swiper library' + e.message);
            throw new Error('Unable to load swiper library' + e.message);
        })
    },
    initReviewSliderInternal: function () {
        if (_internals.mediaChecker.matches === true) {
            if (_internals.reviewSlider) _internals.reviewSlider.destroy(true, true);
        } else {
            _internals.reviewSlider = new _internals.swiper('#reviewSlider', {
                loop: false,
                lazy: true,
                slidesPerView: 3,
                spaceBetween: 20,
                watchSlidesVisibility: true,
                breakpoints: {
                    459: {
                        slidesPerView: 1.4,
                    },
                    767: {
                        slidesPerView: 2.25,
                    }
                }
            });
        }
    },
    initFancyBox: function () {
        import(
            /* webpackChunkName: "fancybox" */
            '@fancyapps/fancybox').then(function (module) {
            console.log('FancyBox loaded');
        }, function (e) {
            console.log('Unable to load fancybox library' + e.message);
            throw new Error('Unable to load fancybox library' + e.message);
        })
    },
    initCompare: function () {
        $(".compare__products").on('scroll', debounce(_internals.scrollCompare, 30));
    },
    scrollCompare: function (e) {
        let current = this;
        $(".compare__products").each(function (index, el) {
            if (el !== current) {
                $(el).scrollLeft($(current).scrollLeft());
            }
        })
    }
};

_internals.initReviewSlider();
_internals.initFancyBox();
_internals.initCompare();